import React, { Component } from 'react';
import ReactBootstrapSlider from 'react-bootstrap-slider';

class PanningComponent extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let className = this.automation !== undefined ?
            'enabled effect effect-automation' : 'effect enabled';
        return (
            <div className={className}>
              <div className="effect-name">Pan</div>
              <div className="clear-fix"></div>
              <div className="parameter-box">
                <ReactBootstrapSlider
                  value={this.props.panning}
                  change={(e) => this.props.onChangePanning(e.target.value)}
                  step={0.01}
                  max={1}
                  min={-1}
                  orientation="horizontal"
                  reversed={false}
                  /> 
              </div>
            </div>);
    }
}

export default PanningComponent;
